import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import 'react';
import PropTypes from 'prop-types';
import { Box } from '@hausgold/designsystem';
import { jsx } from '@emotion/react';
var _excluded = ["children"];
var RendererLayoutContainer = function RendererLayoutContainer(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return jsx(Box, _extends({
    className: "renderer-container"
  }, props), children);
};
RendererLayoutContainer.propTypes = {
  children: PropTypes.node
};
RendererLayoutContainer.defaultProps = {
  children: null
};
export { RendererLayoutContainer as default };